/**
 * Created by lu on 2018/5/4.
 */
var nb = require('../../../nb');
var util = require('../../../util');
module.exports = nb.define({
    parent: nb.Model,
    mapping: {},
    method: {
        init: function () {
            this.onChange('dataReady', function (inEvent) {
                var status = this.get('status');
                var itemCode = this.get('itemCode');
                var price = this.get('price');
                var disPrice = this.get('disPrice');
                var subTotal = this.get('subTotal');
                // var num = this.get('num'); //subTotal

                this.set('itemState', status); //1询过价 0未
                this.set('href', 'productDetail.html?itemCode=' + encodeURI(itemCode));  //转换字符
                this.set('totalPrice', '￥' + subTotal.toFixed(2));//util.numberFormat(num * price / 100, 2)
                this.set('price', '￥' + price.toFixed(2));//util.numberFormat(price / 100, 2)
                this.set('disPrice', '￥' + disPrice.toFixed(2));
            }, this, {before: true});
        }
    }
});
// var id = this.get('id');
// this.set('href','productDetail.html?id='+id);


//////////////////
// WEBPACK FOOTER
// ../src/js/page/order/model/ProductItem.js
// module id = 685
// module chunks = 3